export { getSideBarContextMenu } from './getSideBarContextMenu.js'
export { updateOverlay } from './updateOverlay.js'
export { avatarUrl, avatarUrlFor } from './avatars.js'
export { buildProjectUrls, normalizeProjectKey } from './buildProjectUrls.js'

// Canvas v2
export {
  patchCanvas,
  patchCanvasItem,
  getCanvasV2,
  isCanvasV2,
  getCanvasItem,
  getCanvasSelection,
  getCanvasMode,
  setCanvasV2Mode,
  setViewport,
  applyViewport,
  resetCanvasView,
  initCanvasV2,
  toggleCanvasSettings,
  setCanvasSettings,
  refreshCanvasChrome,
  canvasToScreen,
  screenToCanvas,
  patchSnap,
  fitToSelection,
  toggleShortcutsOverlay,
  persistCanvasLayout,
  addConnection,
  removeConnection
} from './canvas/state.js'

export {
  selectOne,
  toggleSelection,
  selectMany,
  clearSelection,
  isSelected
} from './canvas/selection.js'

export {
  bboxForSelection,
  bboxForGroup,
  itemsInMarqueeRect,
  snapRect
} from './canvas/geom.js'

export {
  trackPointerDown,
  trackPointerMove,
  trackPointerEnd,
  beginDrag,
  applyDragMove,
  beginResize,
  applyResizeMove,
  beginMarquee,
  applyMarqueeMove,
  commitMarquee,
  beginPan,
  applyPanMove,
  beginPinch,
  applyPinchMove,
  onCanvasWheel,
  spawnGuide,
  applySpawnGuideMove,
  beginGuideDrag,
  commitTransient,
  forgetItemRefs
} from './canvas/pointer.js'

export {
  group,
  ungroup,
  collapseGroup,
  groupBbox
} from './canvas/group.js'

export { inspectHover } from './canvas/inspect.js'

export { onCanvasKeydown, onCanvasKeyup } from './canvas/keyboard.js'

export { duplicateSelection, deleteSelection } from './canvas/clipboard.js'

export { autoLayout } from './canvas/autoLayout.js'

export { showContextMenu, hideContextMenu } from './canvas/contextmenu.js'

export { pushHistory, undo, redo } from './canvas/history.js'

export { ensureProjectLoaded, reloadPage } from './canvas/navigation.js'

export { saveMcpConnector, reloadMcpConnectors } from './mcp.js'
